import { render, staticRenderFns } from "./TestsTable.vue?vue&type=template&id=5e0d2359&scoped=true"
import script from "./TestsTable.vue?vue&type=script&lang=js"
export * from "./TestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d2359",
  null
  
)

export default component.exports